import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from '@mui/material';

const DialogoConfirmaExclusaoPreenchedorSSO = ({
  open, onClose, onDelete
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Atenção !!!"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Tem certeza de que deseja excluir este preenchedor SSO?<br></br>
          O SSO segue um fluxo diferente do sistema ESG
          e isto pode causar prejuízos graves para os temas 00a, 03a e 03b!
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={onDelete} autoFocus>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogoConfirmaExclusaoPreenchedorSSO;
